import PropTypes from 'prop-types';

import './SimpleInput.css';

import { buildClass } from '../../libs/classes';

/**
 * Simple input component
 * @component
 */
export const SimpleInput = ({
	placeholder,
	value,
	title,
	className,
	onChange,
	onKeyDown,
	tabIndex,
	limit,
	autoFocus,
}) => {
	return (
		<div className={buildClass('simple-input', className).add(limit, 'limited')}>
			<input
				autoFocus={autoFocus}
				placeholder={placeholder}
				tabIndex={tabIndex}
				title={title}
				type="text"
				value={value}
				onChange={onChange}
				onKeyDown={onKeyDown}
			/>
			{limit > 0 ? (
				<label className="limit" title="Max length">
					{value.length}&thinsp;/&thinsp;{limit}
				</label>
			) : null}
		</div>
	);
};

SimpleInput.propTypes = {
	// Placeholder for unfocused & empty input
	placeholder: PropTypes.string,
	// Value of input
	value: PropTypes.string.isRequired,
	// Title html attribute for component
	title: PropTypes.string,
	// Custom class
	className: PropTypes.string,
	// Callback function on change
	onChange: PropTypes.func,
	// Callback function key down
	onKeyDown: PropTypes.func,
	// Custom tab order of an element
	tabIndex: PropTypes.number,
	// Field length limit
	limit: PropTypes.number,
	// Auto focus flag
	autoFocus: PropTypes.bool,
};

export default SimpleInput;
